import React, { Component } from 'react';

import Header from '../components/Header/Header';
import NFTConsoleOne from '../components/NFTConsole/index'


class NFTConsole extends Component {
    render() {
        return (
            <div className="nft-console-app">
                <Header />
                <NFTConsoleOne />
            </div>
        );
    }
}

export default NFTConsole;
